import { render, staticRenderFns } from "./RecommendKey.vue?vue&type=template&id=4717e61f&scoped=true"
import script from "./RecommendKey.vue?vue&type=script&lang=js"
export * from "./RecommendKey.vue?vue&type=script&lang=js"
import style0 from "./RecommendKey.vue?vue&type=style&index=0&id=4717e61f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4717e61f",
  null
  
)

export default component.exports